var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{key:"collapselogo",staticClass:"sidebar-logo-link",attrs:{"to":"/"}},[_c('img',{staticClass:"sidebar-logo",attrs:{"src":_vm.logo}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }